<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="1000"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <div class="picker">
      <nz-select
        class="variant-select"
        nzShowSearch
        nzServerSearch
        nzAllowClear
        nzPlaceHolder="Artikelvariante suchen"
        [(ngModel)]="selectedVariantId"
        (ngModelChange)="onVariantPicked($event)"
        (nzOnSearch)="onArticleSearch($event)">
        @for (option of articleOptions; track option.id) {
          @if (!isArticlesSearchLoading) {
            <nz-option [nzValue]="variantId(option)" [nzLabel]="option.value"></nz-option>
          }
        }
        @if (isArticlesSearchLoading) {
          <nz-option nzDisabled nzCustomContent>
            <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
          </nz-option>
        }
      </nz-select>
    </div>
    <nz-table
      [nzData]="articles"
      [nzFrontPagination]="false"
      [nzLoading]="isLoading"
      >
      <thead>
        <tr>
          <th>Name</th>
          <th>Art</th>
          <th>Preis</th>
          <th>Preis pro 100</th>
          <th nzWidth="48px"></th>
        </tr>
      </thead>
      <tbody>
        @for (article of articles; track article.id) {
          <tr>
            <td>
              <input type="text" nz-input [(ngModel)]="article.articleName">
            </td>
            <td>
              <nz-select class="category-select" [(ngModel)]="article.category">
                @for (category of outletLabelCategoriesEnum | keyvalue; track category) {
                  <nz-option
                    [nzLabel]="category.value.toString()"
                    [nzValue]="category.value"
                  ></nz-option>
                }
              </nz-select>
            </td>
            <td>
              <div class="d-flex align-items-center flex-nowrap white-space-no-wrap">
                <div class="d-flex align-items-center flex-nowrap">
                  <input
                    type="text"
                    nz-input
                    [(ngModel)]="article.price"
                    appTextInputOnlyNumbers
                    (ngModelChange)="priceChanged(article)"
                    >
                  <span class="currency">
                    &nbsp;€&nbsp;
                  </span>
                </div>
                <div class="weight d-flex align-items-center">
                  /&nbsp;<nz-input-number [nzMin]="1" [(ngModel)]="article.weight" (ngModelChange)="priceChanged(article)"></nz-input-number>&nbsp;<input type="text" nz-input [(ngModel)]="article.unit">
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center flex-nowrap white-space-no-wrap">
                <div class="d-flex align-items-center flex-nowrap">
                  <input
                    type="text"
                    appTextInputOnlyNumbers
                    nz-input
                    [(ngModel)]="article.pricePer100"
                    (ngModelChange)="pricePer100Changed(article)"
                    >
                  <div class="currency">
                    &nbsp;€&nbsp;
                  </div>
                </div>
                <div class="weight">
                  /&nbsp;100 {{ article.unit }}
                </div>
              </div>
            </td>
            <td>
              <button nz-button nzType="text" nzDanger (click)="removeArticle(article)">
                <i nz-icon nzType="delete" nzTheme="outline" nz-tooltip nzTooltipTitle="Entfernen"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
    <div class="d-flex align-items-center" style="gap: 8px; margin-top: 12px;">
      <span>Anzahl Bögen</span>
      <nz-input-number [(ngModel)]="copies" [nzMin]="1" [nzMax]="20" [nzStep]="1"></nz-input-number>
    </div>
  </ng-template>


  <ng-template #modalFooter>
    @if (labelKey) {
      <button [hidden]="true" appOpenPdf [key]="labelKey" #openPdfButtonElRef></button>
    }
    <button nz-button nzType="default" (click)="handleCancel()" [disabled]="isLoading">Schließen</button>
    <button
      nz-button
      nzType="primary"
      (click)="handleOk()"
      [nzLoading]="isConfirmLoading"
      [disabled]="isLoading || articles.length === 0"
    >Drucken</button>
  </ng-template>
</nz-modal>
